import { getLayer } from '@eventbrite/statsig';
import React from 'react';
import { LISTING_PAGE_HERO_CAROUSEL_EXPERIMENT } from '../../../constants';
import type { Event, EventHeroScopedProps } from '../../../types/index';
import './EventHero.scss';
import { HeroCarousel } from './HeroCarousel';
import { HeroImage } from './HeroImage/HeroImage';

export type EventHeroProps = {
    eventName: Event['name'];
    background?: string;
} & EventHeroScopedProps &
    Pick<Event, 'hasCroppedLogo'>;

export const EventHero = ({
    background,
    hasCroppedLogo,
    croppedLogoUrl480,
    croppedLogoUrl600,
    croppedLogoUrl940,
    items = [],
    eventName,
}: EventHeroProps) => {
    const heroCarouselExperimentValue = getLayer(
        LISTING_PAGE_HERO_CAROUSEL_EXPERIMENT.layer,
        LISTING_PAGE_HERO_CAROUSEL_EXPERIMENT.param,
        LISTING_PAGE_HERO_CAROUSEL_EXPERIMENT.defaultValue,
    );
    const isHeroCarouselExperimentEnabled =
        heroCarouselExperimentValue ===
        LISTING_PAGE_HERO_CAROUSEL_EXPERIMENT.carouselVariant;

    const shouldShowCarousel =
        items?.length > 1 && isHeroCarouselExperimentEnabled;

    return (
        <>
            {hasCroppedLogo && (
                <div className="event-hero-wrapper" data-testid="event-hero">
                    <div className="event-hero fx--delay-6 fx--fade-in">
                        <div
                            className="event-hero__background"
                            style={{ backgroundImage: `url("${background}")` }}
                        />
                        {shouldShowCarousel ? (
                            <HeroCarousel eventName={eventName} items={items} />
                        ) : (
                            <HeroImage
                                eventName={eventName}
                                croppedLogoUrl480={croppedLogoUrl480}
                                croppedLogoUrl600={croppedLogoUrl600}
                                croppedLogoUrl940={croppedLogoUrl940}
                            />
                        )}
                    </div>
                </div>
            )}
        </>
    );
};
